import request from '@/router/axios';
// 库存统计查询
export const queryStockWeight = (row) => {
    return request({
        url: '/api/produce/stock-management/select/queryStockWeight',
        method: 'post',
        data: row
    })
}
// 库存列表
export const stockSummaryDetailPage = (row) => {
    return request({
        url: '/api/produce/stock-management/select/stockSummaryDetailPage',
        method: 'post',
        data: row
    })
}
// 历史趋势（折线图）
export const stockSummaryByGroupMonth = (row) => {
    return request({
        url: '/api/produce/stock-management/select/stockSummaryByGroupMonth',
        method: 'post',
        data: row
    })
}